export default __webpack_public_path__ + "static/media/pic5.4d2bc8ea.jpg";